export function getDistanceFromWholeNumber(f) {
  return Math.abs(f - Math.round(f));
}
